import { SapBondStatusSnapshot } from '@/components/Approval/@components/SapBondStatus';
import { parseSapBondStatusContent } from '@/utils/approval/sapBondStatus';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 185 SAP 채권현황 — 저장 content 그대로(레거시 문서 포함). SAP 재조회 안 함 */
const SapBondStatusSlot = ({ data }: ContentExtraProps) => {
  const content = parseSapBondStatusContent(data.attributes);
  if (!content) return null;
  return (
    <ContentSlotRoot>
      <SapBondStatusSnapshot content={content} />
    </ContentSlotRoot>
  );
};

export default SapBondStatusSlot;
